// React Import
import React, { useState } from 'react';

// Package Imports
import { Row, Col, Card } from 'react-bootstrap';
import { observer } from 'mobx-react';
import moment from 'moment';

// Project Imports
import OptionalDetailsCards from '../components/OptionalDetailsCards';
import { Button as UiButton } from "components";
import AddMemberCardModal from "../components/AddMemberCardModal";
import FamilyMemberCardHeader from '../components/FamilyMemberCardHeader';
import AddFamilyMemberData from '../components/AddFamilyMemberData';
import ValidationErrorMessageShowModal from "../components/ValidationErrorMessageShowModal";
import { AddIcon } from "constants/Images";
import EMIOptionalDetailsCards from '../components/EMIOptionalDetailsCard';
import { addEmployees, updateValue, changeFieldValue, toggleDisableOptions, checkIsProtectionNeedSelected, closeModal } from './utils'

// CSS Imports
import "../components/add-family-member-card.css";
import '../family-details-form.css';
import isObjectEmpty from 'utils/isObjectEmpty';
import { useEffect } from 'react';
import AddProposerData from '../components/non-individual-journey/AddProposerData';
import AddLifeAssuredData from '../components/non-individual-journey/AddLifeAssuredData';
import ProposerCardHeader from '../components/non-individual-journey/ProposerCardHeader';
import AddEmployeeCardModal from '../components/non-individual-journey/AddEmployeeCardModal';
import { EMPLOYER_EMPLOYEE_SCHEME_A, EMPLOYER_EMPLOYEE_SCHEME_B, HUF, KEYMAN, MWP_ACT, PARTNERSHIP } from 'constants/ CustomerType';
import AuthStore from 'modules/login/store/AuthStore';
import FamilyMemberTypeEnum from '../FamilymemberTypeEnum';

const EmployeeDetailsForm = ({ formController, errorClass, productDetails }) => {

    const [lastSelectedLA, setLastSelectedLA] = useState("")
    const [lastSelectedPR, setLastSelectedPR] = useState("")
    const [heading, setHeading] = useState(false)
    const [heading2, setHeading2] = useState(false)

    console.log("formController ", formController.get())
    let showProposer = [EMPLOYER_EMPLOYEE_SCHEME_A, HUF, PARTNERSHIP, KEYMAN]

    useEffect(() => {
        if (AuthStore.journeyTypeName === EMPLOYER_EMPLOYEE_SCHEME_B || AuthStore.journeyTypeName === MWP_ACT) {
            if (lastSelectedLA) {
                setLastSelectedPR(lastSelectedLA)
                employeesData.forEach((item, index) => {

                    if (item[0] !== lastSelectedLA) {
                        updateValue(formController, item[0], "life_assured", false)
                        updateValue(formController, item[0], "proposer", false)
                    } else {
                        updateValue(formController, lastSelectedLA, "proposer", true)
                        updateValue(formController, lastSelectedLA, "life_assured", true)
                    }
                })
                familyMemberData.forEach((item, index) => {

                    if (item[0] !== lastSelectedPR) {
                        updateValue(formController, item[0], "life_assured", false)
                        updateValue(formController, item[0], "proposer", false)
                    } else {
                        updateValue(formController, lastSelectedPR, "proposer", true)
                        updateValue(formController, lastSelectedPR, "life_assured", true)
                    }
                })
            }

        } else if (AuthStore.journeyTypeName === EMPLOYER_EMPLOYEE_SCHEME_A || AuthStore.journeyTypeName === PARTNERSHIP || AuthStore.journeyTypeName === KEYMAN) {
            if (lastSelectedLA) {
                setLastSelectedPR(lastSelectedLA)
                employeesData.forEach((item, index) => {
                    if (item[0] !== lastSelectedLA) {
                        updateValue(formController, item[0], "life_assured", false)
                    } else {
                        updateValue(formController, lastSelectedLA, "life_assured", true)
                    }
                })
            }
        } else if (AuthStore.journeyTypeName === HUF) {
            if (lastSelectedLA) {
                setLastSelectedPR(lastSelectedLA)
                familyMemberData.forEach((item, index) => {
                    if (item[0] !== lastSelectedLA) {
                        updateValue(formController, item[0], "life_assured", false)
                    } else {
                        updateValue(formController, lastSelectedLA, "life_assured", true)
                    }
                })
            }
        }
    }, [lastSelectedLA])

    useEffect(() => {
        if (AuthStore.journeyTypeName === EMPLOYER_EMPLOYEE_SCHEME_B || AuthStore.journeyTypeName === MWP_ACT) {
            if (lastSelectedPR) {
                setLastSelectedLA(lastSelectedPR)
                employeesData.forEach((item, index) => {

                    if (item[0] !== lastSelectedPR) {
                        updateValue(formController, item[0], "life_assured", false)
                        updateValue(formController, item[0], "proposer", false)
                    } else {
                        updateValue(formController, lastSelectedPR, "proposer", true)
                        updateValue(formController, lastSelectedPR, "life_assured", true)
                    }
                })
                familyMemberData.forEach((item, index) => {

                    if (item[0] !== lastSelectedPR) {
                        updateValue(formController, item[0], "life_assured", false)
                        updateValue(formController, item[0], "proposer", false)
                    } else {
                        updateValue(formController, lastSelectedPR, "proposer", true)
                        updateValue(formController, lastSelectedPR, "life_assured", true)
                    }
                })
            }

        }
    }, [lastSelectedPR])

    // useEffect(() => {
    //     if (isProtectionNeedSelected) {
    //         setHeading(true)
    //     }
    // }, [])

    let isProtectionNeedSelected = checkIsProtectionNeedSelected(productDetails)

    function setShowFamilymemberModal(shouldShowModal) {
        formController.$("show_add_family_member_modal").value = shouldShowModal;
    }

    if (!formController.has("members")) {
        return null
    }

    let familyData = formController.$("members").get()
    const showFamilyMemberModal = formController.$("show_add_family_member_modal").value;

    const proposerData = Object.entries(familyData).filter((item) => item[0].startsWith("employer"))

    // If Employee Scheme A, Employer Employee Scheme B,Partnership and Keyman Customer Type selected.
    const employeesData = Object.entries(familyData).filter((item) => item[0].startsWith("employee") && item[1]?.value?.is_member_selected)

    //If HUF or MWP Customer Type selected
    const familyMemberData = Object.entries(familyData).filter((item) => item[0]?.startsWith("family_member") && item[1]?.value?.is_member_selected)
    console.log("familyData ", employeesData, familyMemberData)

    function ageValidationOfLA() {
        let validAge = false
        employeesData.forEach((item) => {
            let memberAge = moment().diff(moment(item[1].value.dob), 'years')
            if (memberAge && memberAge > 85 && !validAge) {
                validAge = true
                updateValue(formController, item[0], 'life_assured', false)

            }
        })
        return validAge
    }

    return (
        <Col className='col-12 mb-5'>

            <Card className='border-0 add-family-member-card mt-md-2'>
                <Card.Body className='px-0 pb-0 py-0 border family-member-main-card'>

                    {showProposer.includes(AuthStore.journeyTypeName) &&
                        <>
                            <ProposerCardHeader />
                            <hr className='m-0' />
                        </>

                    }



                    {proposerData.length > 0 &&

                        <AddProposerData
                            employee={proposerData}
                            updateValue={updateValue}
                            formController={formController}
                        />

                    }

                    <FamilyMemberCardHeader />
                    <hr className='m-0' />

                    {/* If HUF Type selected */}
                    {familyMemberData.map((item, index) => {

                        return <AddLifeAssuredData
                            key={index}
                            memberCount={index + 1} // since index starts from 0, therefore added 1 
                            member={item}
                            formController={formController}
                            updateValues={updateValue}
                            onAddNameClick={() => setShowFamilymemberModal(true)}
                            setLastSelectedLa={setLastSelectedLA}
                            setLastSelectedPR={setLastSelectedPR}
                            isProtectionNeedSelected={heading}
                            memberData={familyMemberData}
                            lastSelectedLA={lastSelectedLA}
                        />

                    })

                    }

                    {/* If Employee Scheme A, Employer Employee Scheme B,Partnership and Keyman Customer Type selected. */}
                    {employeesData.map((item, index) => {

                        return <AddLifeAssuredData
                            key={index}
                            memberCount={index + 1} // since index starts from 0, therefore added 1 
                            member={item}
                            formController={formController}
                            updateValues={updateValue}
                            onAddNameClick={() => setShowFamilymemberModal(true)}
                            setLastSelectedLa={setLastSelectedLA}
                            setLastSelectedPR={setLastSelectedPR}
                            isProtectionNeedSelected={heading}
                            memberData={employeesData}
                            lastSelectedLA={lastSelectedLA}
                        />

                    })

                    }
                    <div
                        className='bottom-bg-color p-3 add-member-section'>
                        <UiButton variant='' className='d-inline-flex align-items-center p-0' onClick={() => setShowFamilymemberModal(true)}>
                            <img src={AddIcon} alt='add-icon' className='font-weight-medium' />
                            {employeesData.length > 0 && <p className='mb-0 font-size-12 font-weight-medium text-secondary pl-2'>Add/Edit Employees</p>}
                            {familyMemberData.length > 0 && <p className='mb-0 font-size-12 font-weight-medium text-secondary pl-2'>Add/Edit Family Members</p>}

                        </UiButton>
                    </div>
                </Card.Body>


                <AddEmployeeCardModal
                    formController={formController}
                    updateValues={updateValue}
                    EmployeeList={familyData}
                    show={showFamilyMemberModal}
                    onAddMember={(hideModal) => addEmployees(formController, hideModal)}
                    onHide={() => closeModal(() => setShowFamilymemberModal(false), formController)}
                />
                <ValidationErrorMessageShowModal />
            </Card>

            {  AuthStore.journeyTypeName === MWP_ACT &&
                <Row className='optional-card-row mt-5'>
                <Col className='col-12 col-md-6 col-lg-4 order-lg-1 order-md-1 order-sm-1'>
                    <p className='font-size-14 text-primary font-weight-medium mb-0 mt-4'>
                        Monthly Expense Details
                        {/* <span className={`font-size-11 ${errorClass}`}> - Please fill at least one detail</span> */}
                    </p>
                </Col>
                <Col className='col-12 col-md-6 col-lg-4 order-lg-4 order-md-3 order-sm-2 d-flex'>
                    <OptionalDetailsCards
                        list={formController.$("monthly_expense").get()}
                        onChange={(field_name, value) => {
                            changeFieldValue(formController, 'monthly_expense', field_name, value)
                        }}
                        toggleDisableOption={
                            (field_name, isDisabled) => toggleDisableOptions(formController, 'monthly_expense', field_name, isDisabled)
                        }
                    />
                </Col>
                <Col className='col-12 col-md-6 col-lg-4 order-lg-2 order-md-2 order-sm-3'>
                    <p className='font-size-14 text-primary font-weight-medium mb-0 mt-4'>Monthly EMIs, if any</p>
                </Col>
                <Col className='col-12 col-md-6 col-lg-4 order-lg-5 order-md-4 order-sm-4 d-flex'>
                    {formController.$("show_emi_fields").value == true &&
                        <EMIOptionalDetailsCards
                            list={!isObjectEmpty(formController.$("monthly_emi").get()) && formController.$("monthly_emi").get()}
                            onChange={(field_name, nestedFieldName, value) => {
                                formController.$("monthly_emi").$(field_name).$(nestedFieldName).value = value;
                            }}
                            toggleDisableOption={(field_name, isDisable) => {
                                formController.$("monthly_emi").$(field_name).set("disabled", isDisable);
                                formController.$("monthly_emi").$(field_name).$("option_range").set("disabled", isDisable);
                                formController.$("monthly_emi").$(field_name).$("paid_years").set("disabled", isDisable);
                                formController.$("monthly_emi").$(field_name).$("total_years").set("disabled", isDisable);
                                formController.$("monthly_emi").$(field_name).$("option_range").resetValidation();
                                formController.$("monthly_emi").$(field_name).$("option_range").set("value", {})
                                formController.$("monthly_emi").$(field_name).$("paid_years").resetValidation();
                                formController.$("monthly_emi").$(field_name).$("paid_years").set("value", {})
                                formController.$("monthly_emi").$(field_name).$("total_years").resetValidation();
                                formController.$("monthly_emi").$(field_name).$("total_years").set("value", {})
                            }}
                        />
                    }
                </Col>
                <Col className='col-12 col-md-12 col-lg-4 order-lg-3 order-md-5 order-sm-5'>
                    <p className='font-size-14 text-primary font-weight-medium mb-0 mt-4'>Savings & Investment Details, If any</p>
                </Col>
                <Col className='col-12 col-md-6 col-lg-4 last-card-bottom-spacing order-lg-6 order-md-6 order-sm-6 d-flex'>
                    <OptionalDetailsCards
                        list={formController.$("savings").get()}
                        onChange={(field_name, value) => {
                            changeFieldValue(formController, 'savings', field_name, value)
                        }}
                        toggleDisableOption={
                            (field_name, isDisabled) => toggleDisableOptions(formController, 'savings', field_name, isDisabled)
                        }
                    />
                </Col>
            </Row>
            }
        </Col>

    )

}
export default observer(EmployeeDetailsForm)